import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let OutboundOrder = class OutboundOrder extends Vue {
    constructor(props) {
        super(props);
        this.snackbar = new CBcSnackbar();
        this.listHospital = []; // 医院信息
        this.productList = []; // 产品集合
        this.purchaseContractDist = []; // 采购合同
        this.searchForm = {
            keyword: '',
            displayOption: 0,
            applicationDates: [],
            timer: null,
        };
        this.dialogOrder = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.orderTableOption = {
            loading: false,
            headers: [
                {
                    text: '客户名称',
                    align: 'left',
                    sortable: false,
                    value: 'customerName',
                    width: '200',
                },
                {
                    text: '合同编号',
                    align: 'left',
                    sortable: false,
                    value: 'contractNumber',
                    width: '150',
                },
                {
                    text: '订单编号',
                    align: 'center',
                    sortable: false,
                    value: 'orderNumber',
                    width: '165',
                },
                {
                    text: '订单类型',
                    align: 'center',
                    sortable: false,
                    value: 'orderType',
                    width: '80',
                },
                {
                    text: '申请人',
                    align: 'left',
                    sortable: false,
                    value: 'applicant',
                    width: '100',
                },
                {
                    text: '申请日期',
                    align: 'center',
                    sortable: false,
                    value: 'applicationDate',
                    width: '110',
                },
                {
                    text: '仓库审核',
                    align: 'center',
                    sortable: false,
                    value: 'warehouser',
                    width: '140',
                },
                {
                    text: '销售审核',
                    align: 'center',
                    sortable: false,
                    value: 'auditor',
                    width: '140',
                },
                {
                    text: '财务审核',
                    align: 'center',
                    sortable: true,
                    value: 'financialAuditor',
                    width: '140',
                },
                {
                    text: '出货日期',
                    align: 'center',
                    sortable: false,
                    value: 'shipmentDate',
                    width: '110',
                },
                {
                    text: '到货日期',
                    align: 'center',
                    sortable: false,
                    value: 'arrivalDate',
                    width: '110',
                },
                {
                    text: '订单状态',
                    align: 'center',
                    sortable: false,
                    value: 'orderStatus',
                    width: '140',
                },
                {
                    text: '操作',
                    align: 'center',
                    sortable: false,
                    value: 'action',
                    width: '180',
                },
            ],
            desserts: [],
            pagination: {
                pageCount: 1,
                pageNow: 1,
                pageArr: [5, 10, 20, 50, '所有'],
                everyPageCount: 10,
                sumDetail: 0,
            },
        };
        this.operDateArray = ['shipmentDate', 'arrivalDate', 'applicationDate', 'warehouserDate', 'auditDate', 'financialDate'];
        // 初版订单状态根据确认人信息进入对应的状态，原则上是需要制单人手动提交一次才能进入下一阶段，并且下一阶段不允许修改，初版先不做限制
        this.orderStatusArray = [
            {
                value: 0,
                label: '待提交',
                color: '#607d8b',
            },
            {
                value: 1,
                label: '待补货',
                color: '#5cbbf6',
            },
            {
                value: 2,
                label: '待仓库审核',
                text: '待仓库审核',
                fieldName: 'warehouser',
                fieldDate: 'warehouserDate',
                color: '#2196f3',
            },
            {
                value: 3,
                label: '待销售审核',
                text: '销售审核',
                fieldName: 'auditor',
                fieldDate: 'auditDate',
                color: '#fb8c00',
            },
            {
                value: 4,
                label: '待财务审核',
                text: '财务审核',
                fieldName: 'financialAuditor',
                fieldDate: 'financialDate',
                color: '#44b2d2',
            },
            { value: 5, label: '待发货', color: '#00897B' },
            { value: 6, label: '配送中', color: '#8BC34A' },
            { value: 7, label: '已完成', color: '#4caf50' },
            { value: 8, label: '已作废', color: '#ff5252' },
        ];
        // 订单状态信息
        this.dialogStatus = {
            visible: false,
            loading: false,
            title: '',
            operType: 'confirm',
            form: false,
            formData: {},
            formOption: {},
        };
        // 生产订单申请
        this.dialogApply = {
            visible: false,
            loading: false,
            title: '',
            operType: 'apply',
            form: false,
            formData: {},
            formOption: {},
        };
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        // 变量在构造函数内部进行声名赋值
        const that = this;
    }
    /**
     * 获取表单禁用状态
     */
    get getFormDisabled() {
        const that = this;
        return that.dialogOrder.operType === 'outbound' || that.dialogOrder.operType === 'detail' || that.dialogOrder.operType === 'sign';
    }
    get dateRangeText() {
        let str = '';
        if (this.searchForm.applicationDates.length > 0) {
            str = this.searchForm.applicationDates.join(' ~ ');
        }
        return str;
    }
    /**
     * 生成订单编号
     */
    async generateOrderNo() {
        const that = this;
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const prefix = that.dialogOrder.formData.orderType === '销售' ? 'XS' : that.dialogOrder.formData.orderType === '试用' ? 'CS' : 'YF';
        const randomNumber = Math.floor(Math.random() * 100000)
            .toString()
            .padStart(5, '0');
        const orderNumber = `${prefix}-${year}${month}${day}${randomNumber}`;
        that.$nextTick(() => {
            // 清空这一行
            that.$set(that.dialogOrder.formData, 'orderNumber', orderNumber);
        });
    }
    /**
     * 添加产品容器
     */
    addProductContainer() {
        const that = this;
        if (that.dialogOrder.products.length > 0) {
            // 判断是否有为空的产品容器
            if (that.dialogOrder.products.findIndex((o) => (o.productInfoId || '').length == 0) > -1) {
                that.snackbar.warn('请先填写完毕后增加产品.');
                return;
            }
        }
        that.dialogOrder.products.push({
            outboundOrderId: '',
            productInfo: '',
            productInfoId: '',
            productName: '',
            model: '',
            specifications: '',
            quantity: '0',
            quantityUnit: '',
            remark: '',
        });
        // 在添加控件后滚动到底部
        that.$nextTick(() => {
            that.$refs.refFormPro.$el.scrollTop = that.$refs.refFormPro.$el.scrollHeight;
        });
    }
    /**
     * 删除产品容器
     */
    delProductContainer(index) {
        const that = this;
        that.dialogOrder.products.splice(index, 1);
    }
    getOrderStatusOption(orderStatus) {
        const that = this;
        const option = that.orderStatusArray.find((o) => o.value == orderStatus);
        return option || {};
    }
    /**
     * 保存合同登记
     * @param isDraft 是否保存为草稿
     */
    async saveOrderForm(isDraft = false) {
        const that = this;
        if (!isDraft && !(that.dialogOrder.operType === 'del')) {
            // 一定要关联产品
            if ((that.dialogOrder.products || []).length === 0) {
                that.snackbar.warn('未关联产品，请先关联产品.');
                return;
            }
            if (!that.$refs['refFormPro'].validate()) {
                that.snackbar.warn('请填写必要字段后重新保存.');
                return;
            }
        }
        else {
            // customerName、orderNumber必须不能为空
            if (!that.dialogOrder.formData.customerName) {
                that.snackbar.warn('客户名称不能为空.');
                return;
            }
            if (!that.dialogOrder.formData.orderNumber) {
                that.snackbar.warn('订单编号不能为空.');
                return;
            }
        }
        const form = {
            ...that.dialogOrder.formData,
            products: that.dialogOrder.products || [],
        };
        // 处理收件信息
        form.recipientInfo = {
            address: form.recipientAddress,
        };
        let month = '';
        let url = '/api/erp/order/outbound';
        let msg = '';
        // 添加
        if (that.dialogOrder.operType == 'add') {
            month = 'post';
            msg = '添加';
            // 如果保存是草稿模式
            form.isDraft = isDraft;
        }
        else if (that.dialogOrder.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogOrder.operType == 'outbound') {
            that.orderOutbound(form);
            return;
        }
        else if (that.dialogOrder.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        else if (that.dialogOrder.operType == 'sign') {
            month = 'put';
            url += '/status/' + form.id;
            msg = '签收';
        }
        else if (that.dialogOrder.operType == 'submit') {
            month = 'put';
            url += '/' + form.id;
            msg = '提交';
        }
        that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
    }
    /**
     * 发送订单响应
     */
    async sendOrderSalesResponse(op) {
        const that = this;
        await that.axios[op.month](op.url, op.form)
            .then((res) => {
            that.dialogOrder.loading = false;
            // 提示成功刷新页面
            that.dialogOrder.visible = false;
            that.snackbar.success(`${op.msg}订单信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogOrder.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${op.msg}订单信息错误${resMeg}`);
            console.log(`${op.msg}订单信息错误`, e);
        });
    }
    /**
     * 订单出库，将调整设备实际库存
     */
    async orderOutbound(form) {
        const that = this;
        const forms = [];
        // 组装出库参数，有多少台设备就需要组装多少个
        form.products.forEach((pro) => {
            for (let index = 0; index < pro.devices.length; index++) {
                const deviceNo = pro.devices[index]; // 设备编号
                forms.push({
                    productLine: pro.productInfo.productLine,
                    hospitalId: form.hospitalId,
                    salesOrderId: form.id,
                    salesOrderType: form.orderType,
                    salesOrderNumber: form.orderNumber,
                    productTypeInfoId: pro.productInfo.id,
                    productType: pro.productInfo.category,
                    deviceCode: deviceNo,
                    productName: pro.productName,
                    productShortName: pro.productInfo.shortName,
                    serial: pro.productInfo.serial,
                    model: pro.productInfo.model,
                    specifications: pro.productInfo.specifications,
                    deliveryDate: form.shipmentDate,
                    stockInOutQuantity: pro.productInfo.category === 0 ? 1 : pro.quantity,
                    outboundType: form.orderType,
                    usageLocation: form.recipientAddress,
                    outboundDate: form.shipmentDate,
                    remark: `出库申请单${form.orderNumber}由仓库更改类型自动出库。`,
                });
            }
        });
        await that.axios
            .post('/api/erp/inventory', forms)
            .then(async (res) => {
            that.dialogOrder.loading = false;
            // 提示成功刷新页面
            that.dialogOrder.visible = false;
            // 修改订单状态
            const url = '/api/erp/order/outbound/status/' + form.id;
            await that.sendOrderSalesResponse({
                month: 'put',
                url: url,
                form: { orderStatus: 6, shipmentDate: form.shipmentDate },
                msg: '出库成功，并且更新',
            });
        })
            .catch((e) => {
            that.dialogOrder.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`入库错误${resMeg}`);
            console.log('入库存错误', e);
        });
    }
    /**
     * 显示订单表单
     */
    async showOrderFormClick(operType, row) {
        const that = this;
        // 添加
        async function addFunc() {
            that.dialogOrder.title = '新增出库申请单';
            that.dialogOrder.formData.orderType = '试用';
            that.dialogOrder.formData.applicationDate = new Date().format('yyyy-MM-dd');
            that.dialogOrder.formData.applicant = (that.userInfo || {}).name; // 获取当前操作人
            that.generateOrderNo();
            await that.getProductList();
        }
        // 修改
        async function editFunc() {
            that.dialogOrder.title = '修改出库申请单';
            await that.getProductList();
            that.dialogOrder.products = await that.getoutboundProduct({
                outboundOrderId: row.id,
            });
            if (that.dialogOrder.products.length > 0) {
                that.dialogOrder.products.forEach((item) => {
                    item.productInfo = that.productList.find((o) => o.id == item.productInfoId);
                });
            }
        }
        // 删除
        async function deleteFunc() {
            that.dialogOrder.title = '删除出库申请单';
        }
        // 发货
        async function outboundFunc() {
            that.dialogOrder.title = '仓库发货信息确认';
            await that.getProductList();
            const orderProduct = await that.getoutboundProduct({
                outboundOrderId: row.id,
            });
            if (orderProduct.length > 0) {
                // 处理产品设备库存
                const productInfoIds = orderProduct.map((o) => o.productInfoId);
                const res = await that.axios.get('/api/erp/inventory/product', {
                    params: {
                        productInfoIds: productInfoIds.toString(),
                    },
                });
                const devices = (res.data && res.data.result) || [];
                orderProduct.forEach((item) => {
                    item.productInfo = that.productList.find((o) => o.id == item.productInfoId);
                    item.deviceList = devices.filter((p) => p.productTypeInfoId === item.productInfoId && p.inventory > 0 // 库存大于0
                    );
                    item.devices = [];
                });
            }
            that.dialogOrder.products = orderProduct;
            that.dialogOrder.formData.shipmentDate = new Date().format('yyyy-MM-dd');
        }
        // 完成生产
        async function signFunc() {
            await editFunc();
            that.dialogOrder.title = '客户签收确认';
            that.dialogOrder.formData.orderStatus = 7;
        }
        // 查看明细
        async function detail() {
            await editFunc();
            that.dialogOrder.title = '查看订单详情';
        }
        // 提交出库单，将草稿转为正式
        async function submitOrder() {
            that.dialogOrder.title = '提交出库单';
            that.dialogOrder.formData.orderStatus = 1;
            await editFunc();
        }
        // 生成生产订单
        async function apply() {
            await editFunc();
            const formParams = that.dialogOrder.formData;
            const productArray = [];
            // 处理产品信息，同组的产品信息为一个订单号，通过orderNumber汇总
            formParams.products.forEach((o) => {
                const p = that.productList.find((e) => e.id == o.productInfoId);
                o.orderNumber = p.orderNumber || '-1'; // 分组号，为空时默认为-1
                o.productInfo = p;
                const pa = productArray.find((e) => o.orderNumber == e.orderNumber);
                if (pa) {
                    // 存在就添加数组集合
                    pa.products.push(o);
                }
                else {
                    productArray.push({
                        orderNumber: o.orderNumber,
                        deliveryDate: '',
                        products: [o],
                    });
                }
            });
            that.dialogApply.formData = {
                orderType: formParams.orderType,
                customerName: formParams.customerName,
                docMaker: (that.userInfo || {}).name,
                docDate: new Date().format('yyyy-MM-dd'),
                description: `由出库单【${formParams.orderNumber}】一键生成生产订单。`,
                productArray: productArray,
            };
            that.dialogApply.visible = true;
            that.dialogApply.title = '申请生产订单';
        }
        that.dialogOrder.operType = operType;
        that.dialogOrder.formData = Object.assign({}, row || {});
        that.dialogOrder.products = []; // 清空产品信息
        await that.getPurchaseContractDist();
        await that.initUserList(); // 加载人员字典
        if (operType === 'add') {
            await addFunc();
        }
        else if (operType === 'edit') {
            await editFunc();
        }
        else if (operType === 'outbound') {
            await outboundFunc();
        }
        else if (operType === 'sign') {
            // 签收
            await signFunc();
        }
        else if (operType === 'detail') {
            await detail();
        }
        else if (operType === 'submit') {
            // 提交出库单，
            await submitOrder();
        }
        else if (operType === 'apply') {
            // 生成生产订单
            await apply();
            return;
        }
        else {
            await deleteFunc();
        }
        that.dialogOrder.visible = true;
    }
    /**
     * 获取销售订单产品信息
     */
    async getoutboundProduct(params) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/outbound/product', {
            params: params,
        });
        return (res.data && res.data.result) || [];
    }
    // 医院列表
    async getHospitalList() {
        const that = this;
        // 只需要触发一次
        if ((that.listHospital || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios.get('/api/hospital', { params: { simple: true } }).then((res) => {
                that.listHospital = (res && res.data && res.data.result) || [];
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    // 产品列表
    async getProductList() {
        const that = this;
        const res = await that.axios.get('/api/erp/inventory/statistics');
        that.productList = (res.data && res.data.result) || [];
    }
    productFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['productName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['model'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['shortName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['orderNumber'] || ''));
    }
    purchaseContractFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['contractNumber'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['contractName'].toUpperCase()));
    }
    /**
     * 产品发生变更时
     */
    productInfoChange(row) {
        const that = this;
        // 判断是否有重复的产品
        const index = that.dialogOrder.products.findIndex((o) => o.productInfoId == row.productInfo.id);
        if (index > -1) {
            that.snackbar.warn(`添加产品重复，请直接追加【${row.productInfo.productName}】数量.`);
            that.$nextTick(() => {
                that.setProductInfo({}, row);
                // 清空这一行
                that.$set(row, 'productInfo', null);
            });
            return false;
        }
        that.setProductInfo(row.productInfo, row);
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    setProductInfo(productInfo, row) {
        const that = this;
        row.productInfoId = productInfo.id;
        row.productName = productInfo.productName;
        row.model = productInfo.model;
        row.quantityUnit = productInfo.unit;
        row.specifications = productInfo.specifications;
    }
    inventoryVerify(item) {
        const that = this;
        // 检查库存是否足够，如果不够出库时只能是最大库存数
        const pro = that.productList.find((o) => o.id == item.productInfoId);
        const quantity = Number(pro.usableInventory);
        if (quantity < item.quantity) {
            that.snackbar.warn(`库存不足，最多只能出库${quantity} ${pro.unit}。`);
        }
    }
    verifyDevice(item) {
        // 区分独立设备和包装设备，包装设备时判断库存是否足够
        if (item.productInfo.category === 1) {
            // 这里先不判断，毕竟包装单位的数量好补充
            return item.devices.length > 0;
        }
        // 独立设备验证数量即可
        return item.quantity === item.devices.length;
    }
    /**
     * 验证产品数量函数
     */
    verifyQuantity(item) {
        const that = this;
        // 新增或编辑时才校验
        if (!(that.dialogOrder.operType == 'add' || that.dialogOrder.operType == 'edit' || that.dialogOrder.operType == 'submit')) {
            return true;
        }
        // 订单状态为待提交时不做校验
        if (that.dialogOrder.formData.orderStatus == '0') {
            return true;
        }
        if (!item.quantity)
            return '库存不能为空';
        if (item.quantity <= 0)
            return '库存必须＞0';
        // 库存
        const pro = that.productList.find((o) => o.id == item.productInfoId);
        const quantity = Number(pro.inQuantity - pro.outQuantity);
        if (quantity < item.quantity) {
            return '库存不足';
        }
        return true;
    }
    async getDataList() {
        const that = this;
        that.orderTableOption.loading = true;
        try {
            const res = await that.axios.get('/api/erp/order/outbound', {
                params: {
                    withProducts: true,
                    page: that.orderTableOption.pagination.pageNow,
                    limit: typeof that.orderTableOption.pagination.everyPageCount === 'number'
                        ? that.orderTableOption.pagination.everyPageCount
                        : that.orderTableOption.pagination.sumDetail,
                    keyword: that.searchForm.keyword,
                    hospitalId: that.searchForm.hospitalId,
                    appStartDate: (that.searchForm.applicationDates.length > 0 && that.searchForm.applicationDates[0]) || '',
                    appEndDate: (that.searchForm.applicationDates.length > 1 && that.searchForm.applicationDates[1]) || '',
                    orderType: !/全部|所有/.test(that.searchForm.orderType) ? that.searchForm.orderType : '',
                    orderStatus: (that.searchForm.orderStatus && that.searchForm.orderStatus.toString()) || '',
                },
            });
            that.orderTableOption.desserts = res.data.result || [];
            // 处理签订日期数据
            that.orderTableOption.desserts.forEach((item) => {
                for (let index = 0; index < that.operDateArray.length; index++) {
                    const key = that.operDateArray[index];
                    if (item[key])
                        item[key] = new Date(item[key]).format('yyyy-MM-dd');
                }
                let recipientAddress = '';
                if (item.recipientInfo && /object/.test(typeof item.recipientInfo)) {
                    recipientAddress = item.recipientInfo.address || '';
                }
                item.recipientAddress = recipientAddress;
            });
            that.orderTableOption.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.orderTableOption.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.orderTableOption.pagination.everyPageCount) || 1;
            that.orderTableOption.pagination.pageCount = pageCount;
            if (that.orderTableOption.pagination.pageNow > pageCount) {
                that.orderTableOption.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.orderTableOption.loading = false;
        }
    }
    /**
     * 显示订单状态确认表单
     */
    async showStatusFormClick(orderStatus, row) {
        const that = this;
        await that.initUserList();
        // 待提交状态无法审核
        if (row.orderStatus == '0') {
            that.snackbar.warn('出库单未提交，无法审核.');
            return false;
        }
        // 关键信息不填写不让审核
        if (!row.recipientAddress) {
            that.snackbar.warn('收件信息未填写，无法审核.');
            return false;
        }
        if (!row.arrivalDate) {
            that.snackbar.warn('到货日期未填写，无法审核.');
            return false;
        }
        const option = that.orderStatusArray.find((o) => o.value == orderStatus);
        if (!option)
            return;
        that.dialogStatus.title = option.label;
        that.dialogStatus.visible = true;
        that.dialogStatus.formOption = Object.assign({}, option);
        that.dialogStatus.formData = Object.assign({}, row);
        that.dialogStatus.formData.confirmDate = new Date().format('yyyy-MM-dd');
    }
    async saveOrderStatusForm() {
        const that = this;
        if (!that.$refs['refStatusForm'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        // 覆盖表单原有数据
        const form = that.dialogStatus.formData;
        form[that.dialogStatus.formOption.fieldName] = form.confirmName;
        form[that.dialogStatus.formOption.fieldDate] = form.confirmDate;
        await that.axios
            .put('/api/erp/order/outbound/audit/' + form.id, form)
            .then((res) => {
            that.dialogStatus.loading = false;
            // 提示成功刷新页面
            that.dialogStatus.visible = false;
            that.snackbar.success('确认订单信息成功');
            that.getDataList();
        })
            .catch((e) => {
            that.dialogStatus.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`确认订单信息错误${resMeg}`);
            console.log('确认订单信息错误', e);
        });
    }
    /**
     * 查询数据
     */
    searchChange() {
        const that = this;
        clearTimeout(that.searchForm.timer);
        that.searchForm.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    /**
     * 跳转参数处理
     */
    skipParams() {
        const that = this;
        // 合同编号查询
        const keyword = (this.$route.params || {}).keyword || '';
        if (keyword) {
            that.searchForm.keyword = keyword;
        }
    }
    /**
     * 获取采购合同字典数据
     */
    async getPurchaseContractDist() {
        const that = this;
        // 只需要触发一次
        if ((that.purchaseContractDist || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios
                .get('/api/erp/order/purchase/contract', {
                params: { isQueryDist: true },
            })
                .then((res) => {
                that.purchaseContractDist = (res && res.data && res.data.result) || [];
                console.log(res.data.result);
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    async initUserList() {
        const that = this;
        if ((that.userInfoDic.list || []).length > 0) {
            // 已查询过就不在添加
            return;
        }
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    // 删除申请单关联产品
    delApplyProductItem(productIndex, index) {
        const that = this;
        if (that.dialogApply.formData.productArray.length == 1 && that.dialogApply.formData.productArray[0].products.length == 1) {
            that.snackbar.warn('无法删除，至少需要关联一条产品信息。');
            return;
        }
        that.dialogApply.formData.productArray[productIndex].products.splice(index, 1);
        // 如果产品集合中没有其他关联产品后就直接移出
        if (that.dialogApply.formData.productArray[productIndex].products.length == 0) {
            that.dialogApply.formData.productArray.splice(productIndex, 1);
        }
    }
    /**
     * 生成订单编号
     */
    async generateSalesOrderNo(productItem) {
        const that = this;
        const prefix = that.dialogApply.formData.orderType === '销售' ? 'XS' : that.dialogApply.formData.orderType === '试用' ? 'CS' : 'YF';
        const pro = productItem.orderNumber;
        const yrarStr = new Date().getFullYear().toString();
        let orderNumberStr = `${prefix}-${pro}-${yrarStr}`;
        const ret = await that.axios.get('/api/erp/order/sales/quantity', {
            params: { orderNumber: orderNumberStr },
        });
        const suffix = `${(Number(ret && ret.data && ret.data.result) || 0) + 1}`.padStart(3, '0'); // 后缀查询数据库，同订单编号今年订单量，如05的订单编号在2024年已有2条记录，那么最新就是003
        orderNumberStr = `${orderNumberStr}-${suffix}`;
        that.$nextTick(() => {
            // 清空这一行
            that.$set(productItem, 'salesOrderNumber', orderNumberStr);
        });
    }
    async saveApplyOrderForm() {
        const that = this;
        if (!that.$refs['refApplyForm'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        that.dialogApply.loading = true;
        // 循环去保存出库单
        const error = [];
        const success = [];
        const form = that.dialogApply.formData;
        for (let i = 0; i < form.productArray.length; i++) {
            const item = form.productArray[i];
            var queryParams = {
                orderType: form.orderType,
                customerName: form.customerName,
                docMaker: form.docMaker,
                docDate: form.docDate,
                deliveryDate: item.deliveryDate,
                description: form.description,
                orderNumber: item.salesOrderNumber,
                products: item.products,
            };
            await that.axios
                .post('/api/erp/order/sales', queryParams)
                .then((res) => {
                success.push(queryParams.orderNumber);
            })
                .catch((e) => {
                error.push(queryParams.orderNumber);
                console.log(e); // 这里报错是程序问题，提示到前端也没意义
            });
        }
        that.dialogApply.loading = false;
        if (success.length == 0) {
            that.snackbar.error('保存生产订单失败，请联系管理员.');
            return;
        }
        if (error.length == 0) {
            that.snackbar.success('保存生产订单成功');
            that.dialogApply.visible = false;
            return;
        }
        that.snackbar.warn(`[${success.join(',')}]保存成功，[${error.join(',')}]保存失败。`);
    }
    async mounted() {
        const that = this;
        that.skipParams();
        that.getHospitalList();
        that.getDataList();
    }
};
__decorate([
    Getter
], OutboundOrder.prototype, "userInfo", void 0);
OutboundOrder = __decorate([
    Component({
        name: 'OutboundOrder',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], OutboundOrder);
export default OutboundOrder;
